// Leave on a program enrollment Encounter is an 'onleave' statusHistory row; it is open until
// its period has an end (the return day).

const lastLeaveIndex = (statusHistory, predicate = () => true) => {
    for (let i = statusHistory.length - 1; i >= 0; i--) {
        if (statusHistory[i]?.status === 'onleave' && predicate(statusHistory[i])) return i;
    }
    return -1;
};

// End the most recent open leave at `end`. Every other row is left as it is.
export const closeOpenLeave = (encounter, end) => {
    const history = encounter?.statusHistory ?? [];
    const index = lastLeaveIndex(history, (row) => !row.period?.end);
    if (index === -1) return;
    const row = history[index];
    if (row.period) {
        row.period.end = end;
    } else {
        row.period = { end };
    }
};

// Undo the most recent leave (entered in error): drop its row and restore the status before it,
// or 'in-progress' when there is none. statusHistory is spliced in place because assigning an
// object to a fhirworks array property appends it.
export const revertLeave = (encounter) => {
    const history = encounter.statusHistory ?? [];
    const index = lastLeaveIndex(history);
    if (index !== -1) history.splice(index, 1);
    encounter.status = (index > 0 && history[index - 1]?.status) || 'in-progress';
};
